var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import LoaderCard from '../loader-card/LoaderCard';
import { StudentDocumentStatus } from '@/models/StudentDocumentStatus';
let AddPlanStatusDialog = class AddPlanStatusDialog extends Vue {
    constructor() {
        super(...arguments);
        this.formValid = false;
        this.nameRules = [(v) => !!v || 'required'];
        this.isLoading = false;
        this.payload = {
            value: '',
        };
    }
    async createStatus() {
        try {
            await new StudentDocumentStatus()
                .create(this.payload);
        }
        catch (error) {
            //
        }
        this.$emit('onCreated');
        this.closeDialog();
    }
    closeDialog() {
        this.$emit('input', false);
    }
};
AddPlanStatusDialog = __decorate([
    Component({
        components: {
            LoaderCard,
        },
    })
], AddPlanStatusDialog);
export default AddPlanStatusDialog;
